<!-- section start -->
<section class="single-blog-head bg-webp" data-image-src="assets/images/breadcrumb" style="background-image:url('./assets/images/breadcrumb.jpg')">
    <div class="container">
        <div class="row m-t-50 m-b-0">
            <div class="col-12">
                <div class="title title2 title-inner">
                    <div class="main-title">
                        <h2 class="borders text-center color-000"><span>Pilot ERA</span></h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="agency blog-sec blog-sidebar single_blog_item">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 offset-lg-2">
                <div class="box-iframe">
                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe class="embed-responsive-item" src="https://www.google.com/maps/embed?pb=!4v1583806614355!6m8!1m7!1sCAoSLEFGMVFpcE05c0l2clFOOEJGWHVJX01iZmozVlhyb3FZSlRiOUVoWkNFcy1r!2m2!1d6.727156622208031!2d79.90209620293683!3f150.14958231967626!4f-8.308571777919951!5f0.43021794353848797"></iframe>
                    </div>
                </div>
            </div>
        </div>        
        <div class="blog-text">
            <h3 class="blog-head text-center">Street View created with Pilot ERA</h3>
            <div class="blog-divider"></div>
            <div class="blog-description border-0 pb-0">
                <!-- TEXT HERE -->
            </div>
        </div>
    </div>
</section>
<!-- section start -->